import { inject, Injectable, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { DialogMessageComponent } from "../components/dialogs/dialog-message/dialog-message";

interface ConfirmationData {
  title: string;
  message: string;
}

@Injectable({
  providedIn: "root",
})
export class ConfirmationDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly translate = inject(TranslateService);

  protected readonly title = signal(this.translate.instant("Global.Confirm.Title"));
  protected readonly message = signal(this.translate.instant("Global.Confirm.Message"));

  constructor() {}

  /**
   * Show a confirmation dialog with custom title and message
   *
   * @param callback function to be called on positive feedback
   * @param data An object containing title and message
   */
  public confirmWithData(callback: () => void, data: ConfirmationData) {
    this.title.set(this.translate.instant(data.title));
    this.message.set(this.translate.instant(data.message));

    this.confirm(callback);
  }

  /**
   * Show a default confirmation dialog
   *
   * @param callback function to be called on positive feedback
   */
  public confirm(callback: () => void): void {
    const dialogRef = this.dialog.open(DialogMessageComponent, {
      data: {
        title: this.title(),
        message: this.message(),
        isConfirm: true,
      },
    });
    dialogRef.componentInstance.emitter.subscribe((bool) => {
      if (bool) {
        callback();
      }
    });
  }
}
